import React, { useState } from 'react';
import { getMeds } from 'store/storeValtio';
import * as mh from 'helpers/medicationHelpers';
import { exportData, isNullOrEmpty, validateEmail } from 'helpers/generalHelpers';
import { sendEmailText } from 'helpers/apiHelpers';
import HelpTitle from 'components/common/HelpTitle';

export default function ExportMedsPrint() {
  const [errors, setErrors] = useState(null);
  const meds = getMeds();
  console.log('ExportMeds');

  function makeMedsList() {
    let medsData = 'Medication List\n\n';
    meds.forEach((m, ix) => {
      if (!m.isPaused) {
        medsData += m.name +'\n'
        medsData += '  FORM:     ' + m.form + ',\n'
        medsData += '  STRENGTH: ' + m.strength + ',\n'
        medsData += '  DOSAGE:   ' + mh.formatDosage(m) + ',\n'
        medsData += '\n'
      }
    });

    return medsData;
  }

  // console.log('medsData', medsData);

  async function sendEmail() {
    let input = document.getElementById("sendEmail"); 
    if (!input || isNullOrEmpty(input.value)) {
      setErrors("Please enter an email address");
      return;
    }
    const email = input.value;
    if (!validateEmail(email)) {
      setErrors("Please enter a valid email address");
      return;
    }
    setErrors(null);
    //console.log('sendEmail', email);
    const medsList = makeMedsList();
    const result = await sendEmailText(email, medsList);
    input.value = '';
    //console.log('sendEmail result', result);
  }

  function handleExport() {
    const medsList = makeMedsList();
    exportData(medsList, "medication-list.txt");
  }

  return (
    <div className='w-full h-full pt-10 flex flex-col justify-normal items-center bg-blue-200'>
      <HelpTitle title="Export MedicationData" helpSubject="ExportMeds" />
      {errors && (
          <div
            className='bg-red-100 rounded-lg py-2 px-10 mb-3 text-base text-red-700'
            role='alert'
          >
            {errors}
          </div>
        )}

      <div className='flex flex-col justify-normal items-center text-xl w-8/12 h-full'>
        <button 
          className='rawBtn w-full h-10 bg-blue-400'
          onClick={()=>handleExport()}
        >
          Save Medication List
        </button>
        <div className='rawBtn flex flex-col justify-normal items-center w-full mt-4 p-4 bg-blue-400 hover:cursor'>
          <div>
            Email Medication List
          </div>
          <div className='min-w-full m-4'>
            <input 
              className='formText'
              id='sendEmail' 
              name='sendEmail' 
              type='email'
              placeholder='email address'
              /> 
            </div>
            <button className='okBtn' onClick={sendEmail}>Send</button>
        </div>
      </div>
    </div>
  );
}
